import React from 'react';
import { useTranslation } from "react-i18next";
import { LocalDateTime, DateTimeFormatter } from "@js-joda/core";
import PlanName from "./PlanName.jsx";
import BillingCycle from "./BillingCycle.jsx";
import {useRenderNumber} from "../../../api/utilities/useValueRenderers.js";

const CurrentPlanBox = ({ project, currencySymbol }) => {
    const { t } = useTranslation();
    const subscription = project.subscription;
    const subscriptionPackage = subscription?.currentPackage;

    const renderNumber = useRenderNumber();

    if (!subscription || !subscriptionPackage) {
        return null;
    }

    const billingCycle = subscription.billingCycle;

    let price = renderNumber(subscriptionPackage.monthlyCzk);
    if (billingCycle === 'annual') {
        price = renderNumber(subscriptionPackage.yearlyCzk * 12);
    }

    const isTrial = subscription.isFreeTrial;

    const expires = LocalDateTime.parse(subscription.endDate);
    const expiresString = expires.format(DateTimeFormatter.ofPattern('dd.MM.yyyy'));

    const nextPackage = subscription.nextPackage || subscriptionPackage;
    const nextBillingCycle = subscription.nextBillingCycle || billingCycle;

    let nextPrice = renderNumber(nextPackage.monthlyCzk);
    if (nextBillingCycle === 'annual') {
        nextPrice = renderNumber(nextPackage.yearlyCzk * 12);
    }

    const subscriptionText = isTrial
        ? t('subscription.free-trial-ends-on')
        : t('subscription.current-subscription-ends-on');

    return (
        <>
            <div className="text-xs font-bold text-gray-900 align-top mb-1">{t('subscription.active-package')}:</div>
            <div
                className="mb-8 w-full h-full text-left py-3 px-4 rounded-lg bg-white dark:bg-gray-800 border border-gray-400 dark:border-gray-700/60 shadow-sm transition">

                <div className="flex flex-wrap items-center justify-between mb-0.5">
                    <div className={'flex gap-1'}>
                        <PlanName
                            planName={subscriptionPackage.name}
                            className={'font-semibold text-md text-gray-800 dark:text-gray-100'}
                        />
                    </div>
                    <span className={'flex items-baseline'}>
                        <span className="font-medium text-green-600">{price} {currencySymbol}</span>
                        <BillingCycle
                            billingCycle={billingCycle}
                            className={'text-sm font-thin text-gray-500'}
                            text={'/'}
                        />
                    </span>
                </div>
                <div className="text-xs mt-2">
                    {subscriptionText} <strong>{expiresString}</strong>,
                    {subscriptionPackage.id === nextPackage.id ? (
                        <span> {t('subscription.afterwards-will-renew-for')} </span>
                    ) : (
                        <span> {t('subscription.afterwards-package-will-change-to')} <strong><PlanName planName={nextPackage.name} /></strong> {t('subscription.and-extended-for')} </span>
                    )}
                    <strong>{nextPrice} {currencySymbol}.</strong>
                </div>
            </div>
        </>
    );
};

export default CurrentPlanBox;